import { Component, Inject, OnInit, PLATFORM_ID, Renderer2 } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, RouterModule } from '@angular/router';
import { CommonModule, DOCUMENT, isPlatformBrowser } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { environment } from '../../../environments/environment';
import { TokenService } from '../../services/token/token.service';
import { MenuHeaderService } from '../../services/menu-header/menu-header.service';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [RouterModule, CommonModule, FormsModule],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent implements OnInit {

  logoPrefeitura: any;
  currentRoute: any;
  rotas: Array<Object> = [];
  corPadraoAmbiente = 'btn-padrao-eicon';
  token: string | undefined;
  isLoading = false;
  nivelDoZoom = 1;
  contrasteAtivado = false;
  menus: any[] = [];
  pergunta = '';
  respostas: string[] = [];
  perguntasAnteriores: string[] = [];

  constructor(private router: Router, private route: ActivatedRoute, private menuService: MenuHeaderService, private tokenService: TokenService,
    private renderer: Renderer2, @Inject(DOCUMENT) private document: Document, @Inject(PLATFORM_ID) private platformId: any
  ) {
    this.logoPrefeitura = environment.logoPrefeitura;
    const url = this.router.url;
    if (url == 'SãoCaetanoSul') {
      this.corPadraoAmbiente = 'btn-padrao-scs';
    } else {
      this.corPadraoAmbiente = 'btn-padrao-eicon';
    }
  }

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      console.log('Navegador');
    }
    this.currentRoute = this.router.url;

    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.currentRoute = event.urlAfterRedirects;
        console.log('this.currentRoute', this.currentRoute);
      }
    });
    this.menuHeader();
  }

  pesquisaNlWeb() {
    if (!this.pergunta.trim()) return;
    this.perguntasAnteriores.push(this.pergunta);

    this.respostas = [];
    this.menuService.buscaNlWeb(this.pergunta, this.perguntasAnteriores).subscribe({
      next: data => {
        const msg = JSON.parse(data);
        const conteudo = msg.content || msg.details || msg.answer;
        if (conteudo) this.respostas.push(conteudo);
      },
      error: erro => console.error('Erro na busca:', erro),
    });
  }

  menuHeader() {
    this.menuService.getMenus().subscribe({
      next: (res: any[]) => {
        this.menus = res;
      },
      error: (erro) => {
        console.error('Erro ao buscar menus:', erro);
      }
    });
  }

  getParentMenus() {
    return this.menus.filter(menu => !menu.fkSeqFaixaNavegacao);
  }

  getSubMenus(menu: any) {
    return this.menus.filter(m => m.fkSeqFaixaNavegacao === menu.seqFaixaNavegacao);
  }

  hasSubMenus(menu: any) {
    return this.getSubMenus(menu).length > 0;
  }

  onLinkClick() {
    this.isLoading = true;
    setTimeout(() => {
      this.isLoading = false;
    }, 2000);
  }

  zoomIn() {
    this.nivelDoZoom += 0.1;
    document.body.style.setProperty('zoom', this.nivelDoZoom.toString());
    (document.querySelector('.top-header') as HTMLElement).style.setProperty('zoom', (1 / this.nivelDoZoom).toString());
  }

  zoomNormal() {
    this.nivelDoZoom = 1.0;
    document.body.style.setProperty('zoom', this.nivelDoZoom.toString());
    (document.querySelector('.top-header') as HTMLElement).style.setProperty('zoom', (1 / this.nivelDoZoom).toString());
  }

  zoomOut() {
    if (this.nivelDoZoom > 1) {
      this.nivelDoZoom -= 0.1;
      document.body.style.setProperty('zoom', this.nivelDoZoom.toString());
      (document.querySelector('.top-header') as HTMLElement).style.setProperty('zoom', (1 / this.nivelDoZoom).toString());
    }
  }

  contraste() {
    const aplicarCor = (elementos: NodeListOf<Element>, corFundo: string, corTexto: string) => {
      elementos.forEach((el) => {
        (el as HTMLElement).style.backgroundColor = corFundo;
        (el as HTMLElement).style.fill = corTexto;
      });
    };

    this.contrasteAtivado = !this.contrasteAtivado;
    if (this.contrasteAtivado) {
      this.renderer.addClass(this.document.body, 'alto-contraste');
      aplicarCor(document.querySelectorAll('Prefeitura_Demonstracao'), "white", "yellow");
    } else {
      this.renderer.removeClass(this.document.body, 'alto-contraste');
    }
  }

  normalizeInternalUrl(url: string): string {
    return url.startsWith('/') ? url : `/${url}`;
  }

  isExternal(url: string): boolean {
    return /^https?:\/\//.test(url);
  }
}
